// extracted by mini-css-extract-plugin
export default {"subheader":"_4eadac6287187ecd"};